/* This is the EMIS School Construction components */

<template>
  <v-container>
    <div>
      <span v-html="title"></span>
    </div>
    <div>
      <table
        style="height: 43px"
        width="370px;"
        border="1px;"
        cellspacing="0px;"
      >
        <tbody>
          <tr>
            <td
              style="
                width: 250px;
                height: 25px;
                text-align: center;
                vertical-align: middle;
              "
            >
              ប្រភេទសំណង់
            </td>
            <td class="row-data">ចំនួនអគារ</td>
            <td class="row-data">ចំនួនបន្ទប់</td>
          </tr>
          <tr v-for="(value, row) in e2.length" :key="row">
            <td
              style="
                width: 250px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              {{ e2[row] }}
            </td>
            <td
              v-for="(value, col) in data[row].dt.length"
              :key="col"
              class="row-data"
            >
              <numberinput v-model="data[row].dt[col]" class="number" />
            </td>
          </tr>
          <tr>
            <td
              style="
                width: 250px;
                height: 25px;
                text-align: left;
                vertical-align: middle;
              "
            >
              សរុប
            </td>
            <td class="row-data">{{ totalRow[0] }}</td>
            <td class="row-data">{{ totalRow[1] }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </v-container>
</template>

<script>
import { e2 } from "@/utils/priascf/commonVariables.js";
import NumberInput from "@/components/common/NumberInput.vue";
export default {
  props: ["data", "title"],
  components: {
    numberinput: NumberInput,
  },
  data() {
    return {
      e2: e2,
    };
  },
  computed: {
    totalRow: function () {
      let result;
      let d = this.data;

      result = d.reduce(function (r, a, ind) {
        a.dt.forEach(function (b, i) {
          r[i] = (r[i] || 0) + Number(b);
        });
        return r;
      }, []);
      return result;

      /*
      return d.reduce(function(a, cv){
    		return a.dt.map(function(v, i){
        	return v + cv[i];
    		});
			});
			
			var sum = (r, a) => r.map((b, i) => a[i] + b);
			console.log([[1, 2, 3, 4], [5, 6, 7, 8], [9, 10, 11, 12]].reduce(sum));
			*/
      //var sum = (r, a) => r.map((b, i) => a[i] + b);
      //return d.reduce(sum);
    },
  },
};
</script>
<style scoped>
.number {
  width: 60px;
  text-align: center;
}
.row-data {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
}
.row-data-gray {
  width: 60px;
  height: 25px;
  text-align: center;
  vertical-align: middle;
  background-color: lightgray;
}
</style>